export const DATA_HOOKS = {
  okButton: 'ok button',
  cancelButton: 'cancel button',
};
